import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPage() {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0B1A2E] text-[#F1F5F9] flex flex-col selection:bg-[#2DD4BF]/30 selection:text-white" data-id="element-123">
      <main className="flex-grow max-w-3xl mx-auto w-full px-4 py-16 md:py-24" data-id="element-124">
        <Link to="/" className="inline-flex items-center gap-2 text-[#2DD4BF] hover:text-[#14B8A6] hover:underline mb-12 transition-colors font-medium" data-id="element-125">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-126" />
          <span data-id="element-127">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-8" data-id="element-128">
          Privacy Policy
        </h1>

        <div className="space-y-8 text-[#94A3B8] leading-relaxed" data-id="element-129">
          <p data-id="element-130">Last updated: {new Date().toLocaleDateString()}</p>

          <section data-id="element-131">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-132">
              1. Information We Collect
            </h2>
            <p className="mb-4" data-id="element-133">
              When you purchase the ADHD Executive Function Toolkit, we collect
              the necessary information to process your transaction and deliver
              the digital product. This includes your name, email address, and
              payment information. We do not store full credit card details on
              our servers; these are securely processed by our payment provider.
            </p>
          </section>

          <section data-id="element-134">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-135">
              2. How We Use Your Information
            </h2>
            <p className="mb-4" data-id="element-136">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-137">
              <li data-id="element-138">Process your payment and deliver the digital toolkit.</li>
              <li data-id="element-139">Send you important updates regarding your purchase.</li>
              <li data-id="element-140">
                Respond to your customer service requests and support needs.
              </li>
              <li data-id="element-141">Improve our website and product offerings.</li>
            </ul>
          </section>

          <section data-id="element-142">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-143">
              3. Information Sharing
            </h2>
            <p className="mb-4" data-id="element-144">
              We do not sell, trade, or otherwise transfer your personally
              identifiable information to outside parties. This does not include
              trusted third parties who assist us in operating our website,
              conducting our business, or servicing you, so long as those
              parties agree to keep this information confidential.
            </p>
          </section>

          <section data-id="element-145">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-146">
              4. Data Security
            </h2>
            <p className="mb-4" data-id="element-147">
              We implement a variety of security measures to maintain the safety
              of your personal information when you place an order or enter,
              submit, or access your personal information. All supplied
              sensitive/credit information is transmitted via Secure Socket
              Layer (SSL) technology.
            </p>
          </section>

          <section data-id="element-148">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-149">
              5. Contact Us
            </h2>
            <p className="mb-4" data-id="element-150">
              If there are any questions regarding this privacy policy, you may
              contact us using the information below:
              <br data-id="element-151" />
              <a href="mailto:support@adhdtoolkit.com" className="text-[#2DD4BF] hover:underline mt-2 inline-block" data-id="element-152">
                support@adhdtoolkit.com
              </a>
            </p>
          </section>
        </div>
      </main>

      <Footer data-id="element-153" />
    </div>;
}